var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7797 6.53026L9.52951 11.7804C9.42462 11.8853 9.29099 11.9567 9.14552 11.9856C9.00006 12.0145 8.84928 11.9997 8.71225 11.9429C8.57522 11.8862 8.45809 11.7901 8.37568 11.6667C8.29326 11.5434 8.24926 11.3985 8.24923 11.2501V9.01253C3.25364 9.18248 1.29467 11.0158 1.27457 11.0352C1.15887 11.1475 1.01009 11.2197 0.850221 11.2409C0.690356 11.2622 0.527894 11.2314 0.386862 11.1532C0.245829 11.075 0.133713 10.9534 0.0670926 10.8066C0.000472327 10.6597 -0.0171148 10.4953 0.0169318 10.3377C0.0326822 10.2665 1.61327 3.50423 8.24923 3.02662V0.74986C8.24926 0.601544 8.29326 0.456566 8.37568 0.333255C8.45809 0.209945 8.57522 0.113837 8.71225 0.0570834C8.84928 0.00032935 9.00006 -0.0145235 9.14552 0.0144029C9.29099 0.0433294 9.42462 0.114736 9.52951 0.219596L14.7797 5.46974C14.8493 5.53935 14.9046 5.62201 14.9423 5.713C14.98 5.80398 14.9994 5.90151 14.9994 6C14.9994 6.09849 14.98 6.19602 14.9423 6.287C14.9046 6.37799 14.8493 6.46065 14.7797 6.53026Z",
    fill: "#2B96DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.939c975a765b5f89259b2b5334d5f318.svg";
export { ForwardRef as ReactComponent };